import {ReactComponent as TrophyOne} from '../trophy-1.svg';
import {ReactComponent as TrophyTwo} from '../trophy-2.svg';
import {ReactComponent as TrophyThree} from '../trophy-3.svg';

const PlaceIcon = props =>
     (
       <span>
         {(props.index === 0) && <TrophyOne style={{width:props.size, height:props.size}}/>}
         {(props.index === 1) && <TrophyTwo style={{width:props.size, height:props.size}}/>}
         {(props.index === 2) && <TrophyThree style={{width:props.size, height:props.size}}/>}
       </span>
     )

export default PlaceIcon
